import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import FlatButtonFilters from 'components/consumer/FlatButtonFilters';
import IconSearch from 'components/icons/IconSearch';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import LivestreamVideoThumbnail from '../LivestreamVideoThumbnail';
const LivestreamLatestVideosUI = t0 => {
  const $ = _c(25);
  const {
    searchText,
    setSearchText,
    selectedFilter,
    setSelectedFilter,
    videoCategories: t1,
    videos: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const videoCategories = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const videos = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h3 className="text-3xl font-bold text-gray m-0">Latest videos</h3>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== selectedFilter || $[6] !== setSelectedFilter || $[7] !== videoCategories) {
    t6 = <div className="mt-4 mx-0 mb-0 lg:m-0"><FlatButtonFilters items={videoCategories} selectedItem={selectedFilter} setSelectedItem={setSelectedFilter} showMarginBottom={false} scrollOnMobile={true} /></div>;
    $[5] = selectedFilter;
    $[6] = setSelectedFilter;
    $[7] = videoCategories;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== setSearchText) {
    t7 = event => {
      setSearchText(event.target.value);
    };
    $[9] = setSearchText;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IconSearch />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== searchText || $[13] !== t7) {
    t9 = <div className="md:w-[calc((100%_-_1.75rem)_/2)] lg:w-[calc((100%_-_3.5rem)_/3)]"><LabeledTextInput className="mt-6 mx-0 mb-4 lg:m-0" label="Search videos" value={searchText} onChange={t7} action={t8} actionAlignment="left" actionStretchHeight={true} variant="livestream-search" /></div>;
    $[12] = searchText;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <div className="flex flex-col mx-0 my-4 lg:items-end lg:flex-row lg:justify-between lg:mt-0 lg:mx-0 lg:mb-9">{t6}{t9}</div>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== videos) {
    t11 = videos.map(_temp);
    $[18] = videos;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <div className="grid gap-7 pb-8 md:grid-cols-[1fr_1fr] lg:grid-cols-[1fr_1fr_1fr]">{t11}</div>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t12) {
    t13 = <div className="mt-10 lg:mt-24">{t5}{t10}{t12}</div>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
LivestreamLatestVideosUI.propTypes = {
  searchText: PropTypes.string,
  setSearchText: PropTypes.func,
  selectedFilter: PropTypes.string,
  setSelectedFilter: PropTypes.func,
  videoCategories: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string
  })),
  videos: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.string,
    image: PropTypes.string,
    isRecordedLive: PropTypes.bool,
    title: PropTypes.string,
    videoId: PropTypes.string,
    videoLength: PropTypes.string
  }))
};
export default LivestreamLatestVideosUI;
function _temp(t0) {
  const {
    slug,
    category,
    image,
    isNowPlaying,
    isRecordedLive,
    isSelected,
    title,
    videoLength,
    videoType,
    videoId
  } = t0;
  return <LivestreamVideoThumbnail slug={slug} category={category} image={image} isNowPlaying={isNowPlaying} isRecordedLive={isRecordedLive} isSelected={isSelected} title={title} videoLength={videoLength} videoType={videoType} videoId={videoId} />;
}